import { ApolloError, useMutation } from "@apollo/client";
import { LogoutUserDocument } from "@clockwise/web-commons/src/mutations/__generated__/LogoutUser.generated";
import { track, TrackingEvents } from "@clockwise/web-commons/src/util/analytics.util";
import { doUserLogout } from "@src/util/auth.util";
import { useCallback } from "react";

type Props = {
  clientMutationId?: string;
  onError?: (error: ApolloError) => void;
};

type Result = [
  () => Promise<void>,
  {
    loading: boolean;
    error: ApolloError | undefined;
  },
];

export function useLogout({ clientMutationId, onError }: Props = {}): Result {
  const [logout, { loading, error }] = useMutation(LogoutUserDocument, {
    variables: { clientMutationId },
    onError,
  });

  const onLogout = useCallback(async () => {
    track(TrackingEvents.AUTH.BEGIN_LOGOUT);
    const result = await logout();
    if (result.data?.logoutUser?.user?.__typename === "User") {
      doUserLogout();
    }
  }, [logout]);

  return [onLogout, { loading, error }];
}
